export default "__VITE_ASSET__dhPlJ_Bz__"